var React = require('react');

function ThreeDotsInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.00008 5.33366C8.73341 5.33366 9.33341 4.73366 9.33341 4.00033C9.33341 3.26699 8.73341 2.66699 8.00008 2.66699C7.26675 2.66699 6.66675 3.26699 6.66675 4.00033C6.66675 4.73366 7.26675 5.33366 8.00008 5.33366ZM8.00008 6.66699C7.26675 6.66699 6.66675 7.26699 6.66675 8.00033C6.66675 8.73366 7.26675 9.33366 8.00008 9.33366C8.73341 9.33366 9.33341 8.73366 9.33341 8.00033C9.33341 7.26699 8.73341 6.66699 8.00008 6.66699ZM6.66675 12.0003C6.66675 11.267 7.26675 10.667 8.00008 10.667C8.73341 10.667 9.33341 11.267 9.33341 12.0003C9.33341 12.7337 8.73341 13.3337 8.00008 13.3337C7.26675 13.3337 6.66675 12.7337 6.66675 12.0003Z","fill":"black","fillOpacity":"0.54"}));
}

ThreeDotsInfo.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ThreeDotsInfo;

ThreeDotsInfo.default = ThreeDotsInfo;
